import * as SearchActions from './search.actions';
import * as DocumentQueryActions from './document-query.actions';
import * as ImageQueryActions from './image-query.actions';

export {
    SearchActions,
    DocumentQueryActions,
    ImageQueryActions
};
